<template>
  <nav 
    v-if="breadCrumbList.length > 1"
    aria-label="Breadcrumb" 
    class="cxco-c-breadcrumb"
  >
    <ol class="cxco-c-breadcrumb__list">
      <li
        class="cxco-c-breadcrumb__item"
        v-bind:key="breadcrumb.id"
        v-for="breadcrumb in breadCrumbList"
      >
        <button
          class="cxco-c-breadcrumb__link"
          @click="handleBreadcrumbClick(breadcrumb)"
          :aria-current="breadcrumb.depth === this.state.depth ? 'location' : undefined"
          :aria-label="`Go to category ${breadcrumb.name}`"
          type="button"
        >
          {{ breadcrumb.name }}
        </button>
      </li>
    </ol>
  </nav>
</template>
<script>
import { inject } from "vue";
import { renderFlatActiveCategoryTree, getCategoryById, toggleCategory } from "../utils";
export default {
  setup() {
    const state = inject("state");
    const actions = inject("actions");
    return { state, actions };
  },
  computed: {
    breadCrumbList() {
      const flatTree =renderFlatActiveCategoryTree(this.state);
      return flatTree || []
    },
  },
  methods: {
    handleBreadcrumbClick(breadcrumb) {

      // When clicking breadcrumb, we want to navigate without toggling
      this.actions.selectCategory(breadcrumb, false);
    }
  }
};
</script>
